import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import type { ITableEditablePasswordCell } from '../types';

import { Eye, EyeOff } from '@/assets/icons';

const TableEditablePasswordCell = ({
  defaultValue,
  isEditable,
  onChange,
}: ITableEditablePasswordCell): React.ReactElement => {
  const [value, setValue] = useState<string>(defaultValue);
  const [isFieldReadable, setIsFieldReadable] = useState<boolean>(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (!isEditable) {
      setIsFieldReadable(false);
    }
  }, [isEditable]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const onBlur = () => {
    onChange(value);
  };

  return (
    <>
      <TableCellInput
        type={isFieldReadable ? 'text' : 'password'}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={!isEditable}
      />
      <ToggleVisibilityBtn
        isReadable={isFieldReadable}
        onClick={() => setIsFieldReadable(!isFieldReadable)}
      ></ToggleVisibilityBtn>
    </>
  );
};

export { TableEditablePasswordCell };

const TableCellInput = styled.input`
  height: 28px;
  margin: 2px;
  padding-left: 8px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background-color: #fff;
  width: calc(100% - 2px);

  &:disabled {
    border: none;
    margin-left: 0;
    padding-left: 0;
  }
`;

const ToggleVisibilityBtn = styled.span<{ isReadable: boolean; onClick?: () => void }>`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 17px;

  margin-left: -25px;

  background-image: url(${({ isReadable }) => (isReadable ? Eye : EyeOff)});
  background-position: center top 4px;
  background-repeat: no-repeat;
  background-size: 15px;

  cursor: pointer;
  z-index: 2;
`;
